<template>
    <div id="addTheoryTopic">

        <el-form
            :model="topicForm"
            :rules="topicRules"
            class="topic-form"
            ref="topicForm"
            :label-width="$i18n.locale === 'zh-CN' ? '120px': '180px'">

            <div class="select-group">
                <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                    <el-select v-model="topicForm.forLevel" :placeholder="$t('tip.operatorLevel')" style="width:210px;">
                        <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                    <el-select v-model="topicForm.difficulty" :placeholder="$t('tip.difficulty')" style="width:210px;">
                        <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                    <el-cascader
                        v-model="topicForm.knowledge"
                        :options="knowledgeMenu['Theory']"
                        :props="cascadeProp"
                        :show-all-levels="false"
                        style="width:210px;"
                    ></el-cascader>
                </el-form-item>
            </div>

            <el-form-item :label="$t('topic.questionDesc')"  class="rt-form-item">
                <quill-editor v-model="titleRT" ref="titleRT"></quill-editor>
            </el-form-item>

            <!-- 单选 -->
            <div v-if="theoryType === 1" class="options-box">
                <el-form-item :label="$t('topic.optionDesc')" class="rt-form-item">
                    <div class="option-item" v-for="(item, index) in optionRT" :key="index">
                        <!-- 因为几个radio互相无关联，表现类似于多选框，所以要在点击时取消其他radio的值 -->
                        <el-radio v-model="item.isRight" :label="true" @click.native="singleChange(index)">
                            {{String.fromCharCode(65+index)}}
                            <span class="right" v-if="item.isRight">（{{$t('topic.rightOption')}}）</span>
                        </el-radio>
                        <quill-editor v-model="item.titleRT" ref="optionRT"></quill-editor>
                        <a class="btn-delete" @click="deleteOption(index)"><i class="nucfont inuc-remove-circle"></i></a>
                    </div>

                    <el-button class="btn-add-option" :disabled="optionRT.length>6" @click="addOption" size="medium">增加选项</el-button>
                </el-form-item>
            </div>

            <!-- 多选 -->
            <div v-if="theoryType === 2" class="options-box">
                <el-form-item :label="$t('topic.optionDesc')" class="rt-form-item">
                    <div class="option-item" v-for="(item, index) in optionRT" :key="index">
                        <el-checkbox v-model="item.isRight">
                            {{String.fromCharCode(65+index)}}
                            <span class="right" v-if="item.isRight">（{{$t('topic.rightOption')}}）</span>
                        </el-checkbox>
                        <quill-editor v-model="item.titleRT" ref="optionRT"></quill-editor>
                        <a class="btn-delete" @click="deleteOption(index)"><i class="nucfont inuc-remove-circle"></i></a>
                    </div>

                    <el-button class="btn-add-option" v-if="optionRT.length<7" @click="addOption" size="medium">增加选项</el-button>
                </el-form-item>
            </div>

            <!-- 判断 -->
            <div v-if="theoryType === 3" class="options-box">
                <el-form-item :label="$t('topic.optionDesc')">
                    <el-radio v-model="isJudgeRight" :label="true">{{$t('c.right')}}</el-radio>
                    <el-radio v-model="isJudgeRight" :label="false">{{$t('c.wrong')}}</el-radio>
                </el-form-item>
            </div>

            <el-form-item label=" " class="analysis">
                <el-collapse v-model="activeNames" accordion>
                    <el-collapse-item :title="$t('topic.addOrEditAnalyse')" name="1">
                        <quill-editor v-model="analysisRT" ref="analysisRT"></quill-editor>
                    </el-collapse-item>
                </el-collapse>
            </el-form-item>
        </el-form>

        <div class="btn-group">
            <el-button @click="$router.back()" size="medium">取消</el-button>
            <el-button type="primary" @click="saveTopicForm" size="medium" :loading="topicLoading">{{$t('c.save')}}</el-button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Cascade } from '@/utils';
    import api from '@/api';
    import QuillEditor from "@/components/QuillEditor"

    export default {
        props: {
            theoryType: {
                type: Number
            },
            topicID: {}
        },
        components: {
            QuillEditor
        },
        data() {
            return {
                activeNames: '0',
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                topicForm: {
                    difficulty: '',
                    forLevel: '',
                    knowledge: [],
                },
                isJudgeRight: true,
                topicLoading: false,
                topicRules: {
                    forLevel: [
                        {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                    ],
                    difficulty: [
                        {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                    ],
                    knowledge: [
                        {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                    ],
                    title: [
                        {required: true, message: this.$t('tip.titleDesc'), trigger: 'change'}
                    ],
                },
                difficultyDict: [],

                editData: null,

                titleRT: '',
                analysisRT: '',
                optionRT: [{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                }],
            }
        },

        mounted() {
            this.$store.dispatch('getForLevelMenu');

            // 拿到知识点之后再去加载数据
            this.$store.dispatch('getKnowledgeMenu', {
                type: 'Theory'
            }).then(data => {
                if (this.topicID) {
                    this.initEditData();
                }
            });

            api.getDifficulty().then(res => {
                this.difficultyDict = res.package;
            });
        },

        computed: {
            ...mapGetters([
                'forLevelMenu',
                'knowledgeMenu'
            ]),
        },

        watch: {
            theoryType(val, oldVal) {
                this.clearForm();
            },
        },

        methods: {
            initEditData() {
                api.getTheoryTopicDetail(this.topicID).then(res => {
                    this.editData = res.package;

                    this.topicForm = {
                        difficulty: this.editData.difficulty,
                        forLevel: this.editData.forLevel,
                        knowledge: Cascade.fullPath(this.knowledgeMenu['Theory'], this.editData.knowledge)
                    };

                    if (this.theoryType === 3) {
                        this.isJudgeRight = this.editData.options.find(ele => ele.tag === 1).isRight;
                    }

                    this.initEditorData();
                })
            },

            initEditorData() {
                console.log(this.editData)
                this.titleRT = this.editData.titleRT
                this.analysisRT = this.editData.analysisRT
                if (this.theoryType!==3) {
                    this.optionRT = this.editData.options.map(item => {
                        return {
                            titleRT: '',
                            isRight: false
                        }
                    })
                    this.$nextTick(() => {
                        this.optionRT = this.editData.options.map(item => {
                            return {
                                titleRT: item.titleRT,
                                isRight: item.isRight
                            }
                        })
                    })
                }
            },

            addOption() {
                this.optionRT.push({
                    titleRT: '',
                    isRight: false,
                })
            },
            deleteOption(index) {
                this.optionRT.splice(index, 1)
            },
            singleChange(index) {
                this.optionRT.forEach((v, i) => {
                    if (i !== index) {
                        v.isRight = false
                    }
                })
            },

            saveTopicForm() {
                let title = this.$refs.titleRT.quill.getText()

                let data = Object.assign({}, this.topicForm, {
                    title,
                    titleRT: this.titleRT,
                    analysis: this.$refs.analysisRT.quill.getText(),
                    analysisRT: this.analysisRT,
                    type: this.theoryType,
                    knowledge: this.topicForm.knowledge[this.topicForm.knowledge.length - 1],
                    options: []
                });

                this.$refs['topicForm'].validate((valid) => {
                    if (!valid) {
                        $('.el-main').scrollTop(0)
                        return;
                    }

                    if (!title.trim()) {
                        return this.error(this.$t('tip.titleDesc') + '！');
                    }

                    if (this.theoryType === 1 || this.theoryType === 2) {
                        if (!this.optionRT.find(item => item.isRight)) {
                            return this.error(this.$t('tip.chooseRightAnswer') + '！');
                        }

                        if (this.optionRT.length < 2) {
                            return this.error('选择题至少包含两个选项！')
                        }

                        let hasEmptyOption = false
                        this.$refs.optionRT.forEach((item, i) => {
                            data.options.push({
                                tag: 65 + i,
                                title: item.currentText,
                                titleRT: item.currentValue,
                                isRight: this.optionRT[i].isRight
                            })
                            if (!item.currentText.trim()) {
                                hasEmptyOption = true
                            }
                        })

                        if (hasEmptyOption) {
                            this.error(this.$t('tip.optionDesc') + '！');
                            return;
                        }
                    }

                    if (this.theoryType === 3) {
                        data.options = [{
                            tag: 1,
                            title: '',
                            titleRT: '',
                            isRight: this.isJudgeRight === true
                        }, {
                            tag: 0,
                            title: '',
                            titleRT: '',
                            isRight: this.isJudgeRight === false
                        }];
                    }

                    this.topicLoading = true;

                    // 提交逻辑
                    //editTheoryTopic
                    if (this.topicID) {
                        api.editTheoryTopic(this.topicID, data).then(res => {
                            this.topicLoading = false;

                            this.$message({
                                message: this.$t('m.editSuccess'),
                                type: 'success'
                            });

                            this.$router.back();

                        }).catch(error => this.topicLoading = false);
                    } else {
                        api.addTheoryTopic(data).then(res => {
                            this.topicLoading = false;

                            this.$message({
                                message: this.$t('m.addSuccess'),
                                type: 'success'
                            });

                            this.$router.back();

                        }).catch(error => this.topicLoading = false);
                    }

                });
            },

            clearForm() {
                this.$refs['topicForm'] && this.$refs['topicForm'].resetFields();

                this.optionRT = [{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                },{
                    titleRT: '',
                    isRight: false,
                }]
                this.isJudgeRight = true
            },

            error(msg) {
                this.$message({
                    message: msg,
                    type: 'error'
                });
            }

        },
    }
</script>

<style scoped lang="scss">
    .topic-form {
        width: 1030px;
        @media screen and (max-width: 1280px) {
            width: 800px;
        }
    }

    .select-group {
        margin-bottom: 10px;

        .el-form-item {
            display: inline-block;
        }
    }

    .el-select-dropdown__item {
        width: 210px;
    }

    .options-box {
        .option-item {
            position: relative;
            padding: 10px 0;
            > label {
                display: block;
                padding-bottom: 10px;
            }
        }
        .right {
            color: #ff4081;
        }
        .btn-delete {
            position: absolute;
            right: 14%;
            top: 45%;
            padding: 12px;
            color: #999;
            cursor: pointer;
            &:hover {
                color: $red;
            }
            .nucfont {
                font-size: 20px;
            }
        }
    }

    .btn-add-option {
        display: block;
        margin-top: 10px;
    }

    .btn-group {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px 0;
        text-align: center;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-shadow: 0 2px 8px #ccc;
        z-index: 1;

        button {
            letter-spacing: 4px;

            + button {
                margin-left: 15px;
            }
        }
    }
</style>

<style lang="scss">
    @import '../../../style/const';

    #addTheoryTopic {
        .analysis {
            padding-bottom: 20px;
            > .el-form-item__content {
                width: 80%;
                @media screen and (max-width: 1280px) {
                    width: 75%;
                }
            }

            .el-collapse,
            .el-collapse-item__wrap {
                border: none;
            }

            .el-collapse-item {
                border: dashed 1px #999;
                border-left: none;
                border-right: none;
            }

            .el-collapse-item__header {
                font-size: 15px;
                height: 32px;
                line-height: 32px;
                color: #999;
                text-align: center;
                border: none;
            }

            .el-collapse-item__arrow {
                float: none;
                display: inline-block;
                line-height: 32px;
            }
        }

        .el-form-item__label {
            color: $c-txt;
        }

        .rt-form-item {
            .el-form-item__label {
                line-height: 1;
                padding-top: 10px;
            }
            .el-form-item__content {
                line-height: 1;
            }
        }
        .quill-editor {
            width: 80%;
            .ql-editor {
                min-height: 100px;
            }
        }
    }

</style>
